import react, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLanguage } from "./LanguageContext";
import { setLanguage } from './utils';
import { textTranslations } from "./header/text-translations";
import { openMessengerApp } from "./utils";

const Header = () => {

    const [navOpen, setNavOpen] = useState(false);

    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useOutletContext(false);

    const { language, changeLanguage } = useLanguage();

    const handleLogoClick = () => {
        window.open("/", "_self");
    }

     let handleOpenMessengerApp = (platform) => {
        let linkBody = ""
        if(platform == "whatsapp") {
          linkBody = "Okay, Boggler... What do you have to say?";
    
          if(language === "sinhala") {
            linkBody = "උදව් කරන්න! මගේ පෙම්වතා මට ආපහු ආදරේ කරන්නේ නැහැ!"
          }
        } else {
          linkBody = "Okay, Boggler... What do you have to say?"
          if(language == "sinhala") {
            linkBody = "උදව් කරන්න! මගේ පෙම්වතා මට ආපහු ආදරේ කරන්නේ නැහැ!"
          }
        }
        
        let smsLive = process.env.REACT_APP_SMS_LIVE || false;
        let whatsappLive = process.env.REACT_APP_WHATSAPP_LIVE || false;
        if(process.env.REACT_APP_QA_MODE === "true" || process.env.REACT_APP_QA_MODE === true) {
          showAlert(true);
        } else {
          if(platform === "sms" && smsLive == "false") {
            setShowAlert(true);
            return;
          } else if(platform === "whatsapp" && whatsappLive == "false") {
            setShowAlert(true);
            return;
          } else {
            openMessengerApp(linkBody, platform);
          }
        }
      }

    return (
        <header className="mobile-header">
            <div className="header-row">
                <img
                    onClick={handleLogoClick}
                    src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.png"
                    alt="Boggler Logo"
                    className="header-logo"
                    loading="lazy"
                    style={{ borderRadius: 8 }}
                />
            <button
                className="hamburger"
                aria-label="Open navigation"
                onClick={() => setNavOpen(!navOpen)}
            >
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
            </button>
            </div>
            <nav className={`main-nav${navOpen ? " open" : " closed"}`}>
                <span className="cta-button header-button header-button-buckish" onClick={() => window.open("https://theboggler.com", "_self")}>Home</span>
                <span className="header-button header-button-contact" onClick={() => navigate("/", "_self")}>Log In</span>
                {/* <span className="header-button header-button-sinhala sinhala-button" 
                    onClick={() => {
                        setLanguage(language === "sinhala" ? "english" : "sinhala")
                        changeLanguage(language === "sinhala" ? "english" : "sinhala");
                    }}
                >{language === "english" ? "සිංහල" : "English?"}</span> */}
            </nav>
        </header>
    )
}

export default Header;